import { ceil } from 'lodash';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import CommonTable from '../Table/CommonTable';
import { API_END_POINT, TOKEN } from '../../constant';
import Loader from '../Loader/Loader';
import axios from 'axios';
import { toast } from 'react-toastify';
import { IoCloudUploadOutline } from "react-icons/io5";

function GemstoneUpload() {
  const { gemstoneId } = useParams();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false)
  const [gemstoneImageData, setGemstoneImageData] = useState([])

  const getGemstoneImage = async () => {
    setLoading(true)
    const getGemstoneImageUrl = `${API_END_POINT}gemstone/fetch-gemstone-images`
    const getGemstoneImageHeaders = {
      'Authorization': `Bearer ${TOKEN}`
    }
    try {
      const gemstoneImageResponse = await axios.get(getGemstoneImageUrl, {
        headers: getGemstoneImageHeaders,
        params: { gemstoneId }
      })
      console.log("this is the response from gemstone image --->>> ", gemstoneImageResponse.data.data)
      setGemstoneImageData(gemstoneImageResponse.data.data)
    } catch (error) {
      toast.error("Failed to fetch gemstone images")
      console.error("GemstoneUpload --->>> getGemstoneImage() --->>> ", error)
    } finally {
      setLoading(false)
    }
  }

  const handleBackClick = () => {
    console.log("this is click")
    navigate('/gemstoneconfiguration')
  }

  const handleImageUpdate = async (mapperId, file) => {
    if (!file) {
      toast.error("Please select image")
      return
    }

    setLoading(true)
    const formData = new FormData();
    formData.append("gemStoneMapperId", mapperId)
    formData.append("file", file)

    try {
      const gemstoneImageUploadUrl = `${API_END_POINT}gemstone/upload-multi-image-file`;

      await axios.post(gemstoneImageUploadUrl, formData, {
        headers: {
          'Authorization': `Bearer ${TOKEN}`,
          'Content-Type': 'multipart/form-data'
        }
      })

      toast.success("Image uploaded successfully!")
      getGemstoneImage()
    } catch (error) {
      console.error("GemstoneUpload --->>> handleImageUpdate() --->>> ", error);
      toast.error("Failed to upload image.");
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    console.log("into the useeffect")
    getGemstoneImage()
  }, [gemstoneId])

  const column = [
    {
      name: 'File ID',
      cell: (row) => row.mapperId
    },
    {
      name: "Image",
      cell: (row) => <img
        title='Click to see Image'
        src={`${API_END_POINT}${row?.fileAttachment?.fileLinkString}`}
        width={"150px"}
        height={"100px"}
        alt="Blog Image"
      />
    },
    {
      name: 'Upload Image',
      cell: (row) => (
        <div className="flex align-center gap-10">
          <label className="flex align-center upload-btn" style={{ cursor: 'pointer' }}>
            <input
              type="file"
              style={{ display: 'none' }}
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  handleImageUpdate(row.mapperId, file);
                } else {
                  toast.error("No file selected");
                }
              }}
            />
            <IoCloudUploadOutline
              style={{
                width: "25px",
                height: "25px",
                color: "currentColor"
              }}
            />
          </label>
        </div>
      )
    }
  ]

  return (
    <div>
      {!loading ? (
        <div className='main'>
          <h3 className='heding'>Gemstone Configuration {gemstoneId}</h3>
          <button style={{ width: 'fit-content', height: '40px', margin: '10px' }} className='common-btn align-center' onClick={handleBackClick} >
            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>

          <CommonTable data={gemstoneImageData} columns={column} />
        </div>
      ) : (
        <Loader />
      )}
    </div>
  )
}

export default GemstoneUpload
